import State from "./stores/State"
import { browserHistory } from "react-router"
import { throttle } from "lodash/function"
import { getAccountSettings } from "./scripts/accountSettings"

const noHeaderRegex = /^\/(login|register|reset-password|confirm-email|change-password|unlock-account)/
const noFilterRegex = /^\/(collections?|sets?)/ // we don't use search filters on these pages, so turn off

export const getClassNames = (url, authenticAccountId) => {
  const accountSettings = getAccountSettings(authenticAccountId)
  const {
    style: { content }
  } = accountSettings.settings

  const viewSize = State.get("viewSize")
  const result = {
    "state-search-focussed": State.get("searchFocused"),
    "state-filters-expanded":
      State.get("showSearchFilters") && !url.match(noFilterRegex),
    "state-search-submitting":
      State.get("searchLoading") || State.get("doQuery"),
    "state-search-map": State.get("searchMap"),
    "state-site-nav-expanded": State.get("navExpanded"),
    "state-header-hidden": State.get("headerHidden"),
    "state-notification-visible": State.get("notificationVisible"),
    "browser-support-visible": State.get("browserSupportVisible"),
    "view--has-chrome": State.get("viewHasChrome"),
    "view--no-chrome": !State.get("viewHasChrome"),
    "view--no-header-pad":
      content === "default"
        ? State.get("viewDisableHeaderPad") || url.match(noHeaderRegex)
        : url.match(noHeaderRegex),
    // 'view--no-footer': State.get('viewDisableHeaderPad'), //url.match(/^\/item/), //
    "view--small": viewSize === "small",
    "view--medium": viewSize === "medium",
    "view--large": viewSize === "large",
    "view--xlarge": viewSize === "xlarge",
    "view--xxlarge": viewSize === "xxlarge"
  }

  result[content] = true

  return result
}

const applyClassNames = throttle(url => {
  const classNames = getClassNames(url)

  for (const className in classNames) {
    // console.log((classNames[className] ? 'adding' : 'removing') +' body class '+className)
    document.body.classList.toggle(className, classNames[className])
  }
}, 300)

export function addBodyClassListener() {
  require("./scripts/classList") // polyfill for ie10

  let pathname = document.location.pathname

  State.addListener(() => {
    applyClassNames(pathname)
  })

  browserHistory.listen(function(event) {
    pathname = event.pathname
    applyClassNames(pathname)
  })
}



// WEBPACK FOOTER //
// ./webapp/bodyClasses.js